import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Section } from '../section/section.model';
import { CalculatedValues } from './calculatedValues.model';

@Component({
  selector: 'document-competition-law',
  templateUrl: './competition-law.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./competition-law.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CompetitionLawComponent implements OnInit {
  @Input() keywords: string[];
  @Input() emphasisSections: Section[];
  @Input() countryCode: string;
  @Input() calculatedValues: CalculatedValues[];
  @Input() documentType: string;
  @Input() infringements: Section;
  @Input() aim: Section;
  @Input() target: Section;
  @Input() dmaSubthemes: Section;
  @Input() dmaCps: Section;
  @Input() dmaEmphasisSections: Section[];

  constructor() {}

  ngOnInit(): void {
    // console.log(this.keywords);
    // console.log(this.emphasisSections);
  }

  hideSections(name: string) {
    if (
      name === 'section.sa_duration' ||
      name === 'section.sa_total_amount' ||
      name === 'section.sa_eligible_costs' ||
      name === 'section.sa_aid_intensity' ||
      name === 'section.sa_amount_per_year' ||
      name === 'section.sa_aim' ||
      name === 'section.sa_target'
    ) {
      return name;
    }
  }

  displayData(data: string) {
    if (data) {
      return data;
    } else {
      return 'Not applicable or available';
    }
  }

  getSectionByName(name: string) {
    const table = this.emphasisSections.filter(
      (section) => section.name === name
    );
    if (table.length == 0) {
      return null;
    } else {
      return table[0].answer;
    }
  }

  private sortSubthemes(): (a: HTMLLIElement, b: HTMLLIElement) => number {
    return (a, b) => {
      if (a.innerText.startsWith('Other') && !b.innerText.startsWith('Other')) {
        return 1;
      } else if (
        b.innerText.startsWith('Other') &&
        !a.innerText.startsWith('Other')
      ) {
        return -1;
      } else {
        return a.innerText.localeCompare(b.innerText);
      }
    };
  }

  displayTags(answer: string, name: string): string {
    console.log(`Processing displayTags for name: ${name}`);
    const div = document.createElement('div');
    div.innerHTML = answer.trim();
    const arrayOfElements = Array.from(div.getElementsByTagName('li'))
      .map((li) => {
        const code = li.getAttribute('code') || '';
        let keyword = li.textContent?.trim() || '';
        keyword = keyword.replace('(CPS)', '').trim();
        console.log(`Extracted keyword: "${keyword}", code: "${code}"`);
        const a = document.createElement('a');
        a.textContent = keyword;
        const url = this.generateUrl(name, code);
        if (url) {
          a.setAttribute('href', encodeURI(url));
        } else {
          console.warn(`No URL generated for name: ${name}, code: ${code}`);
        }
        li.innerHTML = '';
        li.removeAttribute('code');
        li.appendChild(a);
        return li;
      })
      .sort(this.sortSubthemes());
    const result = document.createElement('ul');
    result.classList.add('Tags-list');
    arrayOfElements.forEach((li) => result.appendChild(li));
    return result.outerHTML;
  }

  private generateUrl(name: string, code: string): string {
    const base = `/client/site/case-database/${this.documentType}`;
    const queryParams = new URLSearchParams();
    const rules: Record<string, () => void> = {
      'STATE_AID|section.sa_target': () => queryParams.set('themes', code),
      'COMPETITION_LAW_DOC|Infringements': () => {
        queryParams.set('themes', this.keywords[0]);
        queryParams.set('subthemes', code);
      },
      'DMA_CASE|section.dma_sub_theme': () => {
        queryParams.set('themes', this.keywords[0]);
        queryParams.set('subthemes', code);
      },
      'DMA_CASE|section.dma_core_platform': () => queryParams.set('types', code),
    };
    const key = `${this.documentType}|${name}`;
    if (rules[key]) {
      rules[key]();
      return `${base}?${queryParams.toString()}`;
    }
    console.warn(`No URL rule for name: ${name}`);
    return '';
  }

  displayStateAidSubthemeTags(targetAnswer: string, aimAnswer: string) {
    // Get first target as theme
    const span = document.createElement('span');
    span.innerHTML = targetAnswer.trim();
    const targets = span.getElementsByTagName('li');
    let arrayOfTargets = Array.from(targets);
    const target = arrayOfTargets[0].getAttribute('code');
    // Create <div> to inject new dom
    const div = document.createElement('div');
    div.innerHTML = aimAnswer.trim();
    // Create array of <li>, sort and inject <a> inside
    const lis = div.getElementsByTagName('li');
    let arrayOfElements = Array.from(lis);
    arrayOfElements.sort(this.sortSubthemes());
    for (let index = 0; index < arrayOfElements.length; index++) {
      const li = arrayOfElements[index];
      const keyword = li.textContent;
      const aim = li.getAttribute('code');
      li.innerText = '';
      li.removeAttribute('code');
      const a = document.createElement('a');
      li.appendChild(a);
      a.innerText = keyword;
      const queryStateAidSubthemes =
        '/client/site/case-database/' +
        this.documentType +
        '?themes=' +
        target +
        '&subthemes=' +
        aim;
      a.setAttribute('href', encodeURI(queryStateAidSubthemes));
    }
    // Prepare the resutl dom with only <ul>
    const result = document.createElement('ul');
    // Add class on <ul>
    result.setAttribute('class', 'Tags-list');
    for (let index = 0; index < arrayOfElements.length; index++) {
      result.appendChild(arrayOfElements[index]);
    }
    return result.outerHTML;
  }

  hasAmountSectionValues(): boolean {
    const sections = [
      this.getSectionByName('section.sa_aid_intensity'),
      this.getSectionByName('section.sa_total_amount'),
      this.getSectionByName('section.sa_duration'),
      this.getSectionByName('section.sa_amount_per_year'),
      this.getSectionByName('section.sa_eligible_costs'),
    ];
    return sections.some((section) => !!section);
  }
  
  isDmaCompanySection(typeName: string): boolean {
    const validTypeNames = [
      'dma_authorities',
      'cl_reference',
      //'dma_core_platform',
      'dma_outcome',
      'dma_outcome_text',
      'dma_sub_theme',
      'legalBasis'
    ];
    return validTypeNames.includes(typeName);
  }
  
}
